import { useSelector } from 'react-redux';

import { selectOfferType } from '../../../../selectors';

export const SUBURBAN_TITLE = 'История объявлений рядом';

export const DEFAULT_TITLE = 'История объявлений в этом и соседних домах';

export const useTitle = () => {
  const offerType = useSelector(selectOfferType);

  return offerType === 'suburban' ? SUBURBAN_TITLE : DEFAULT_TITLE;
};
